var _path, _g, _path2, _g2, _rect, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 344,
    viewBox: "0 0 640 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_692_36949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 153,
    width: 239,
    height: 159
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6705 243.062L46.4182 184.72L12.9811 198.06L86.728 283.678L120.165 270.338L165.677 252.181L216.582 311.28L250.019 297.94L199.114 238.841L227.907 227.353L204.412 200.077L175.619 211.564L125.367 153.223L91.93 166.563L142.182 224.904L96.6705 243.062Z",
    fill: "#4671F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_692_36949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6705 243.062L46.4182 184.72L12.9811 198.06L86.728 283.678L120.165 270.338L165.677 252.181L216.582 311.28L250.019 297.94L199.114 238.841L227.907 227.353L204.412 200.077L175.619 211.564L125.367 153.223L91.93 166.563L142.182 224.904L96.6705 243.062Z",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.55164,
    y: 182.777,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.5516,
    y: 138.777,
    width: 41,
    height: 66,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0516 224.401L142.052 224.901L142.052 288.401L97.0516 288.401L97.0516 224.401Z",
    fill: "#7294FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_692_36949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 392,
    y: 1,
    width: 236,
    height: 191
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.019 145.94L502.367 1.2229L468.93 14.563L468.997 14.6403L392.233 45.266L415.727 72.5424L492.491 41.9168L520.248 74.1411L442.233 105.266L465.727 132.542L543.742 101.418L570.09 132.007L489.233 164.266L512.727 191.542L595.391 158.563L595.388 158.559L627.019 145.94Z",
    fill: "#4671F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_692_36949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.019 145.94L502.367 1.2229L468.93 14.563L468.997 14.6403L392.233 45.266L415.727 72.5424L492.491 41.9168L520.248 74.1411L442.233 105.266L465.727 132.542L543.742 101.418L570.09 132.007L489.233 164.266L512.727 191.542L595.391 158.563L595.388 158.559L627.019 145.94Z",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: -0.7771,
    width: 118,
    height: 74,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 452,
    y: 132.223,
    width: 118,
    height: 74,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 402,
    y: 74.2229,
    width: 118,
    height: 74,
    fill: "#7294FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_692_36949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 59,
    width: 303,
    height: 217
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 191,
    transform: "matrix(0.652627 0.757679 -0.92881 0.370557 359.427 59.8424)",
    fill: "#4671F6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_692_36949)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 191,
    transform: "matrix(0.652627 0.757679 -0.92881 0.370557 359.427 59.8424)",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.397,
    y: 54.5787,
    width: 183,
    height: 230,
    fill: "#7294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.448 183.349C309.448 167.161 321.639 149.172 336.675 143.173C351.711 137.175 363.902 145.436 363.902 161.625L377.515 156.193C377.515 131.907 359.233 119.517 336.675 128.516C314.118 137.516 295.835 164.494 295.835 188.78L309.448 183.349ZM377.515 258.791L295.835 291.378C284.556 295.878 275.415 289.683 275.415 277.54L275.415 218.912C275.415 206.769 284.556 193.28 295.835 188.78L377.515 156.193C388.794 151.694 397.936 157.889 397.936 170.032L397.936 228.659C397.936 240.802 388.794 254.291 377.515 258.791Z",
    fill: "url(#paint0_linear_692_36949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.515 262.791L303.835 295.378C292.556 299.878 283.415 293.683 283.415 281.54L283.415 222.912C283.415 210.769 292.556 197.28 303.835 192.78L385.515 160.193C396.794 155.694 405.936 161.889 405.936 174.032L405.936 232.659C405.936 244.802 396.794 258.291 385.515 262.791Z",
    fill: "#ECEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.448 187.349C317.448 171.161 329.639 153.172 344.675 147.173C359.711 141.175 371.902 149.436 371.902 165.625L385.515 160.193C385.515 135.907 367.233 123.517 344.675 132.516C322.118 141.516 303.835 168.494 303.835 192.78L317.448 187.349Z",
    fill: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.675 213.129C337.154 216.13 331.062 225.119 331.062 233.217C331.062 241.315 337.154 245.443 344.675 242.443C352.197 239.442 358.289 230.452 358.289 222.355C358.289 214.257 352.197 210.128 344.675 213.129Z",
    fill: "#B9C9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_36949",
    x1: 394,
    y1: 119.223,
    x2: 238.811,
    y2: 241.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2254EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#7294FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.32fc9cde2accc0582d9c55ea4c268321.svg";
export { ForwardRef as ReactComponent };